import { Component, Input, Output, OnDestroy,
         OnChanges, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.less'],
  animations: [
    trigger('slideInOut', [
      state('inLeft', style({transform: 'translateX(100%)'})),
      state('inRight', style({transform: 'translateX(-100%)'})),
      state('void', style({transform: 'translateX(0)'})),
      transition('* => void, void => *', [
        animate('200ms ease-in-out')
      ])
    ]),
    trigger('fadeInOut', [
      state('in', style({opacity: 0.5})),
      state('void', style({opacity: 0})),
      transition('* => void, void => *', [
        animate('200ms ease-in-out')
      ])
    ])
  ]
})

export class DrawerComponent implements OnChanges, OnDestroy {
  @Input() visible: boolean;
  @Input() closeOnOutsideClick: boolean = true;
  @Input() orientation: string = 'right';
  @Input() wide: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() dismissed: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  public ngOnChanges(changes): void {
    if (changes.visible !== undefined) {
      let body = document.getElementsByTagName('body')[0];
      if (changes.visible.currentValue) {
        if (body.className.search('modal-open') === -1){
          body.className = body.className + 'modal-open';
        }
      } else {
        body.className = body.className.replace('modal-open', '');
      }
    }
  }

  public ngOnDestroy() {
    let body = document.getElementsByTagName('body')[0];
    body.className = body.className.replace('modal-open', '');
  }


  public close(): void {
    if (this.closeOnOutsideClick) {
      this.visible = false;
      this.visibleChange.emit(this.visible);
      this.dismissed.emit();
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/drawer/drawer.component.ts